import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import '../../stylesheet/tabdesign.css';
import '../../stylesheet/wallet.css';
import AuthNavbar from '../navigation/authnavigation.jsx';
import iChoose_ApplePay from '../../images/iChoose_ApplePay.png';
import TapandPay from '../../images/TapandPay.png';

import Wallet from '../../images/Wallet.png';
import Secure from '../../images/Secure.png';
import FastPayments from '../../images/FastPayments.png';
import walletIcon from '../../images/walletIcon.png';
import MobilePhoneApple from '../../images/MobilePhoneApple.png';
import NewAppleWalletFullPhone from '../../images/NewAppleWalletFullPhone.png';
import MobilePhoneAppleNZ from '../../images/MobilePhoneApple-nz.png';
import NewAppleWalletFullPhoneNZ from '../../images/NewAppleWalletFullPhone-nz.png';
const mapStateToProps = state =>
({

})
const mapDispatchToProps = dispatch =>
({

})

class AppleWallet extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    // handleChange(e) {
    //     this.setState({
    //         selectedOption: e.target.value
    //     })
    // }
    componentWillMount() {

    }
    componentDidMount() {

    }

    render() {

        var cardTypes = localStorage.getItem('cardTypes')

        return (
            <div className="row">
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="col-md-12 m-0 p-0">
                    <AuthNavbar />
                </div>
                <div className="col-12 bggrey pt-5" style={{ marginTop: "-22px" }}>
                    <div className="container " style={{}}>
                        {/* <div className="row pb-5">
                            <h1>Apple Wallet Page</h1>
                    </div> */}
                        <div className="row marketing bggrey">
                            <div className="col-lg-7 my-auto">
                                <div className="header-content ml-2">
                                    <h2 className="text-center text-sm-left">
                                        KlickEx Money Card now <br />
                                        available with Apple Pay
                                    </h2>
                                    <p className="mb-5">Welcome to easy, fast and secure payments</p>
                                    <img src={iChoose_ApplePay} className="img-fluid" alt="" style={{ height: "60px" }} />
                                </div>
                            </div>
                            <div className="col-lg-5 my-auto">
                                <div className="device-container">
                                    <div className="device-mockup iphone6_plus portrait white">
                                        <div className="device">
                                            <div className="screen">
                                                {localStorage.getItem('pform') === 'AU' ?
                                                    <img src={MobilePhoneApple} className="img-fluid" alt="" />
                                                :
                                                    <img src={MobilePhoneAppleNZ} className="img-fluid" alt="" />
                                                }
                                            </div>
                                            <div className="button">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 ">
                    <div className="container " >
                        <div className="row ">
                            <div className='col-md-12 pt-5 mt-5'> <h2 className="text-center"> Pay safer and faster with Apple Pay.</h2> </div>
                        </div>
                        <div className="row pt-5 pb-5">
                            <div className="col-md-4 col-sm-12 text-center featured-box">
                                <img src={Wallet} style={{maxHeight :'95px'}}/>
                                <h5 className="mt-5" ><strong>Your iPhone is your wallet.</strong></h5>
                                <p>Apple Pay is an easy, secure, and private way to pay—in-store, online, and even in your favorite apps. Available with your KlickEx Money Card on your iPhone, Apple Watch, iPad, and Mac.</p>
                            </div>
                            <div className="col-md-4 col-sm-12 text-center featured-box">
                                <img src={FastPayments} style={{maxHeight :'95px'}} />
                                <h5 className="mt-5" ><strong>Pay easily. Pay fast.</strong></h5>
                                <p>With Apple Pay, you can pay quickly and easily with your KlickEx Money Card right from your iPhone or Apple Watch.</p>
                            </div>
                            <div className="col-md-4 col-sm-12 text-center featured-box">
                                <img src={Secure} style={{maxHeight :'95px'}}/>
                                <h5 className="mt-5" ><strong>Apple Pay. Made to be secure.</strong></h5>
                                <p>Apple Pay is an easy, secure, and private way to pay—in-store, online, and even in your favorite apps. Available with your KlickEx Money Card on your iPhone, Apple Watch, iPad, and Mac.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 bggrey">
                    <div className="container " >

                        <div className="row pt-4 pb-5 bggrey">
                            <div className="col-md-4 col-sm-12 text-center featured-box">
                                <h5 className="mt-5" ><strong>Set up in seconds.</strong></h5>
                                <p>Apple Pay is here and available on all your Apple devices. To get started, open Apple Wallet on your iPhone or Apple Watch, or select Wallet & Apple Pay in System Preferences on your iPad or Mac. Now you're just a few taps away from using Apple Pay with your KlickEx Money Card.</p>
                            </div>
                            <div className="col-md-4 col-sm-12 text-center featured-box">
                                <h5 className="mt-5" ><strong>Pay with just a tap.</strong></h5>
                                <p>With iPhone, double-click the side button, authenticate with Face ID, Touch ID, or your passcode, then hold your device near the reader to pay.
                                    <br />With Apple Watch, just double-click the side button, then hold your device near the reader to finish your purchase</p>
                            </div>
                            <div className="col-md-4 col-sm-12 text-center featured-box">
                                <h5 className="mt-5" ><strong>Use it where you already shop.</strong></h5>
                                <p>To pay with Apple Pay online, in-app, or in-store, just look for or these symbols.</p>
                                <img src={TapandPay} className="tapandpay" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12">
                    <div className="container " >

                        <div className="row pt-4 pb-5">
                            <div className="col-md-6 col-sm-12 text-center pt-4 pb-4">
                                {localStorage.getItem('pform') === 'AU' ?
                                    <img src={NewAppleWalletFullPhone} className=" NewAppleWalletFullPhone img-fluid" alt=""  />
                                :
                                    <img src={NewAppleWalletFullPhoneNZ} className=" NewAppleWalletFullPhone img-fluid" alt=""  />
                                }
                            </div>
                            <div className="col-md-6 col-sm-12 header-content featured-right">
                                <h2 className="mt-5 text-left ml-3" >Adding your KlickEx Money Card is easy.</h2>
                                <img src={walletIcon} className="mb-2 ml-2" style={{height: '50px'}}/> <br/>
                                <p className="text-left ml-3">
                                    Adding your card to Apple Pay is simple. Here's how to get started.
                                </p>
                                
                                <h5 className="mt-5 text-left ml-3" ><strong>To add your KlickEx Money Card to your Apple wallet:</strong></h5>
                                <ol className='text-left ml-5'>
                                    <li>Go to the Wallet app on your mobile device.</li>
                                    <li>Click the plus icon.</li>
                                    <li>Select Debit or Credit Card.</li>
                                    <li>Enter your card details manually.</li>
                                    <li>Accept the T&C's.</li>
                                    <li>Enter the OTP sent via email / sms.</li>
                                    <li>Your card has now been added to your Apple wallet.</li>
                                </ol>

                                <h5 className="mt-1 text-left ml-3" ><strong>Support Links</strong></h5>
                                <p className="mb-1 text-left ml-3"><strong>About Apple Pay:</strong> <a href="https://support.apple.com/kb/HT201469" target="_blank" > https://support.apple.com/kb/HT201469 </a></p>
                                <p className="mb-1 text-left ml-3"><strong>Set up Apple Pay:</strong> <a href="https://support.apple.com/en-gb/108398" target="_blank" > https://support.apple.com/en-gb/108398 </a></p>
                                <p className="mb-1 text-left ml-3"><strong>How to use Apple Pay: </strong><a href="https://support.apple.com/en-gb/102626" target="_blank" > https://support.apple.com/en-gb/102626 </a></p>
                                <p className="mb-1 text-left ml-3"><strong>Apple Pay Privacy:</strong> <a href="https://www.apple.com/legal/privacy/pdfs/apple-privacy-policy-en-ww.pdf" target="_blank" > https://www.apple.com/legal/privacy/pdfs/apple-privacy-policy-en-ww.pdf </a></p>

                                 <iframe width="560" height="306" 
                                    src="https://mydigitalaccount.ichoosecard.com.au/images/applePayvideo640_1.mp4"
                                    allow="accelerometer;  encrypted-media; gyroscope; picture-in-picture" allowFullScreen>
                                </iframe>

                            </div>

                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppleWallet);


// WEBPACK FOOTER //
// ./src/components/wallet/applewallet.jsx